import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const InvoicesListPage = lazy(() => import("@/pages/invoices.index.page"));

export const Route = createFileRoute("/invoices/")({
  component: InvoicesListPage,
});
